import { Loader2Icon } from "lucide-react";

const UpdateProfileFormLoadingState = () => {
	return (
		<div className="mx-auto flex min-h-[400px] w-11/12 max-w-5xl items-center justify-center rounded-lg bg-white p-4 md:p-8">
			<Loader2Icon className="h-16 w-16 animate-spin stroke-brand-primary" />
		</div>
	);
};

export default UpdateProfileFormLoadingState;
